import { createContext } from 'react';

const mentalQueryContext = createContext();

export default mentalQueryContext;
